/**
 * Adds .is-revealed to any [data-scroll-reveal] element once it enters the
 * viewport, via IntersectionObserver. Pure progressive enhancement: styling
 * for the hidden/revealed states lives in theme.scss.liquid, scoped under
 * .js so no-JS visitors always see full content regardless of this script.
 */
(function () {
  if (!('IntersectionObserver' in window)) {
    return;
  }

  var targets = document.querySelectorAll('[data-scroll-reveal]');

  if (!targets.length) {
    return;
  }

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-revealed');
          observer.unobserve(entry.target);
        }
      });
    },
    {
      threshold: 0.15,
      rootMargin: '0px 0px -40px 0px'
    }
  );

  targets.forEach(function (target) {
    observer.observe(target);
  });
})();
